import { render, staticRenderFns } from "./OrigenDeudaForm.vue?vue&type=template&id=48ed6b32&scoped=true"
import script from "./OrigenDeudaForm.vue?vue&type=script&lang=js"
export * from "./OrigenDeudaForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48ed6b32",
  null
  
)

export default component.exports